// FleetView.js — Fleet view (vehicles, maintenance-focused).
import React from 'react';
import { T } from '../lib/crewTokens';
import { CrewGlyph, TruckIcon, FuelGauge } from '../atoms/CrewAtoms';

const CR = T;

// ── Fleet: one row per vehicle, maintenance-focused ──────────
function FleetView({ rows, selected, onSelect, glyph }) {
  // worst vehicles first
  const score = (c) => (c.vehicle.faultCodes.length ? 100 : 0) + (c.vehicle.regDays < 0 ? 80 : 0) + (c.vehicle.openRepairs.some((r) => r.priority === 'high') ? 50 : 0) + (c.vehicle.fuel < 25 ? 40 : 0) + (c.vehicle.mtcOverdueMi ? 30 : 0) + (c.vehicle.regDays >= 0 && c.vehicle.regDays <= 25 ? 20 : 0);
  const sorted = [...rows].sort((a, b) => score(b) - score(a));
  const fmtReg = (d) => d < 0 ? `Expired ${-d}d ago` : d <= 25 ? `Due in ${d}d` : `OK · ${d}d`;
  const regColor = (d) => d < 0 ? CR.rust : d <= 25 ? CR.warn : CR.mute;
  return (
    <div className="card" style={{ overflow: 'auto', maxHeight: '100%' }}>
      <table className="crew-ctbl">
        <thead><tr>
          <th style={{ paddingLeft: 14 }}>Vehicle</th><th>Assigned crew</th><th>Fuel</th><th>Odometer</th>
          <th>Fault codes</th><th>Registration</th><th>Open repairs</th><th style={{ paddingRight: 14 }}>Maintenance</th>
        </tr></thead>
        <tbody>
          {sorted.map((c) => {
            const v = c.vehicle; const isSel = selected && selected.id === c.id;
            return (
              <tr key={c.id} className={isSel ? 'selected' : ''} onClick={() => onSelect(c)} style={{ cursor: 'pointer' }}>
                <td style={{ paddingLeft: 14 }}>
                  <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                    <span style={{ width: 26, height: 26, borderRadius: 7, background: CR.surface3, display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}><TruckIcon size={15} color={CR.ink2} /></span>
                    <span><div style={{ fontWeight: 800, fontSize: 12, fontFamily: CR.mono }}>{v.no}</div><div style={{ fontSize: 9.5, color: CR.muteSoft }}>{v.type}</div></span>
                  </span>
                </td>
                <td style={{ fontSize: 11.5 }}><span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}><CrewGlyph level={c.status.level} variant={glyph} size={14} />{c.name}</span></td>
                <td><FuelGauge pct={v.fuel} width={50} /></td>
                <td style={{ fontFamily: CR.mono, fontSize: 11, color: CR.ink2 }}>{v.odometer != null ? v.odometer.toLocaleString() : '—'} <span style={{ color: CR.muteSoft, fontSize: 9.5 }}>mi</span></td>
                <td>{v.faultCodes.length ? <span style={{ display: 'inline-flex', gap: 4, flexWrap: 'wrap' }}>{v.faultCodes.map((f, i) => <span key={i} style={{ background: CR.rustSoft, color: CR.rust, fontSize: 9.5, fontWeight: 700, fontFamily: CR.mono, padding: '2px 6px', borderRadius: 5 }}>{f}</span>)}</span> : <span style={{ fontSize: 10.5, color: CR.green, fontWeight: 700 }}>None</span>}</td>
                <td style={{ fontSize: 11, fontWeight: 700, color: regColor(v.regDays) }}>{fmtReg(v.regDays)}</td>
                <td>{v.openRepairs.length ? <span style={{ display: 'inline-flex', flexDirection: 'column', gap: 2 }}>{v.openRepairs.map((r, i) => <span key={i} style={{ fontSize: 10.5, color: r.priority === 'high' ? CR.rust : CR.ink2, fontWeight: r.priority === 'high' ? 700 : 500 }}>{r.priority === 'high' ? '● ' : '○ '}{r.item} <span style={{ color: CR.muteSoft, fontSize: 9 }}>{r.age}d</span></span>)}</span> : <span style={{ fontSize: 10.5, color: CR.muteSoft }}>—</span>}</td>
                <td style={{ paddingRight: 14, fontSize: 11, fontWeight: 700, color: v.mtcOverdueMi ? CR.warn : CR.green }}>{v.mtcOverdueMi ? `${v.mtcOverdueMi.toLocaleString()} mi overdue` : 'Current'}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
      {rows.length === 0 && <div style={{ padding: 40, textAlign: 'center', color: CR.muteSoft, fontSize: 12 }}>No vehicles match these filters.</div>}
    </div>
  );
}

export { FleetView };
